import autoComplete from '@tarekraafat/autocomplete.js';
import apiPath from '../../api/apiPath';

export function setupAutoComplete(
    inputSelector,
    navigate,
    getAccessToken,
    pagesUserId
) {
    const searchElement = document.querySelector(inputSelector);
    if (searchElement) {
        new autoComplete({
            data: {
                src: async function () {
                    const query = searchElement.value;
                    if (query.length < 4) {
                        return [];
                    }

                    const accessToken = await getAccessToken();

                    const headers = new Headers({
                        Authorization: `Bearer ${accessToken}`,
                        'Pages-User-Id': pagesUserId
                    });

                    const source = await fetch(
                        apiPath(
                            `/api/typeahead?searchText=${encodeURIComponent(
                                query
                            )}`
                        ),
                        {
                            headers
                        }
                    );
                    const data = await source.json();
                    return data;
                },
                key: ['text'],
                cache: false
            },
            placeHolder: 'Ask a question...',
            selector: inputSelector,
            threshold: 3,
            debounce: 300,
            maxResults: 10,
            highlight: true,
            resultItem: {
                content: function (data, source) {
                    source.innerHTML = data.match;
                },
                element: 'li'
            },
            trigger: {
                event: ['input'],
                condition: (query) => query.trim().length > 3
            },
            onSelection: function (feedback) {
                const selection = feedback.selection.value;
                navigate(selection.url);
            }
        });
    }
}
